import { connect } from 'react-redux'
import { compose } from 'redux'
import withType from 'components/common/hoc/withType'
import { applyFilter } from '../../actions'
import BOTRefinementMenu from './BOTRefinementMenu'

export default compose(
  withType({ type: 'BOTGlobalSearchRefinementMenu' }),
  connect(null, { applyFilter })
)(BOTRefinementMenu)
